export default __webpack_public_path__ + "a1e917cb0262d1221720c4a2add738d3.svg";